export async function fetchSheetGViz(
  spreadsheetId: string,
  sheetName = "Sheet1",
) {
  const url = `https://docs.google.com/spreadsheets/d/${spreadsheetId}/gviz/tq?tqx=out:json&sheet=${encodeURIComponent(
    sheetName,
  )}`;

  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to fetch sheet: ${res.status}`);
  const text = await res.text();

  // GViz wraps JSON in a JS callback. Strip the wrapper and parse JSON.
  const jsonText = text.replace(/^[^{]+/, "").replace(/\);?\s*$/, "");
  const payload = JSON.parse(jsonText);

  const cols = (payload.table.cols || []).map(
    (c: any, i: number) => (c.label && String(c.label).trim()) || `col${i}`,
  );
  const rows = (payload.table.rows || []).map((r: any) =>
    (r.c || []).map((cell: any) => (cell ? cell.v : "")),
  );

  return rows.map((row: any[]) =>
    Object.fromEntries(row.map((v, i) => [cols[i] ?? i, v])),
  );
}

export async function fetchReplicasFAQ(props: {
  spreadsheetId: string;
  sheetName?: string;
  filterByEnv?: boolean;
}) {
  const { spreadsheetId, sheetName = "Sheet1", filterByEnv = true } = props;

  const environment = process.env.REACT_APP_ENVIRONMENT;
  const isProduction = environment === "PRODUCTION";
  const isDevelopment = environment === "DEVELOPMENT";

  const rows = await fetchSheetGViz(spreadsheetId, sheetName);

  const normalize = (s: any) =>
    String(s ?? "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");

  const replicasAll = (rows || [])
    .map((r: any) => {
      const obj: Record<string, any> = Array.isArray(r)
        ? Object.fromEntries(r.map((v: any, i: number) => [`col${i}`, v]))
        : { ...r };

      const replicaRow: Record<string, any> = {};
      Object.entries(obj).forEach(([k, v]) => {
        if (v === null || v === undefined) return;
        const sv = String(v).trim();
        if (sv === "") return;
        replicaRow[normalize(k)] = v;
      });

      return replicaRow;
    })
    .filter((r: any) => {
      if (!filterByEnv) {
        return true;
      }
      return isProduction ? r.prod : isDevelopment ? r.uat : false;
    });

  const replicasByCategory = {};
  replicasAll.forEach((item: any) => {
    const category = item.replica?.trim();
    if (!replicasByCategory[category]) {
      replicasByCategory[category] = [];
    }
    replicasByCategory[category].push(item);
  });

  return { replicasAll, replicasByCategory };
}
